import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

const Clients = ({
  clients_items,
  title,
  text,
  bgColorClassName = 'bg-sky-blue',
  textColorClassName = 'text-dusty-blue-light'
}) => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const containerRef = useRef(null);

  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 1280px)', () => {
      gsap.fromTo(
        titleRef.current,
        { opacity: 0, x: '-5rem' },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
          },
        }
      );

      gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
      {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 75%",  
          scrub: 0.1,  
        },
      });

      gsap.fromTo(
        textRef.current,
        { opacity: 0, x: '-3rem' },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          delay: 0.2,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
          },
        }
      );
    });

    return () => mm.revert();
  }, { scope: sectionRef });

  return (
    <section
      ref={sectionRef}
      className={`container-max overflow-hidden py-[4rem] md:py-[6rem] lg:py-[8rem] xl:py-[10rem] w-full`}
    >
      <div ref={containerRef}>
        <div className="container-padding flex-col container-grid mb-[2rem] lg:mb-[4rem] xl:mb-[8rem]">
          <h2
            ref={titleRef}
            className={`[&>.selected]:italic heading-3 col-span-5 lg:col-span-5 lg:col-start-1 lg:text-right ${'[&>.selected]:'+textColorClassName} mb-[1.6rem] md:mb-[2rem] lg:mb-0 md:col-span-5`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p
            ref={textRef}
            className="lg:flex lg:mt-[0.8rem] xl:mt-[1.4rem] text-1 lg:items-start md:col-span-2 lg:col-span-4 lg:pr-[16%] lg:col-start-7"
          >
            {text}
          </p>
        </div>

        {/* --- MARQUEE SECTION --- */}
        <div className="w-full py-[2rem] md:py-[4rem] lg:py-[6rem] xl:py-[8rem]">
          {/* Note the w-max class added here to wrap the content width exactly */}
          <div className="flex animate-marquee w-max">
            
            {[0, 1].map((_, i) => (
              <div 
                key={i}
                // Padding right matches the gap perfectly to make the loop seamless
                className="flex gap-[5rem] md:gap-[10rem] xl:gap-[14rem] pr-[5rem] md:pr-[10rem] xl:pr-[14rem] shrink-0 items-center"
              >
                {/* No need to duplicate the array here, the [0, 1] map handles the 2 groups */}
                {clients_items.map((item, index) => (
                  <img
                    fetchPriority="low"
                    loading="lazy"
                    key={index}
                    src={item.image.url}
                    width={item.image.width}
                    height={item.image.height}
                    alt={item.name}
                    className="w-auto max-h-[4rem] md:max-h-[6rem] shrink-0 max-w-none object-contain"
                  />
                ))}
              </div>
            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default Clients;